document.addEventListener("DOMContentLoaded", async () => {
  const customerEmail = window.customerEmail;
  const store = Shopify.shop || '';

  if (customerEmail) {
      try {
          // Get the current cart data using Shopify's AJAX API
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                customer_email: customerEmail,
              },
            }),
          });

          const cartResponse = await fetch('/cart.js');
          const { token, items } = await cartResponse.json();
          const updatedToken = token.split('?')[0];

          const line_items = items.map((i) => ({ ...i, price: i.presentment_price ?? i.price / 100}));

          console.log('line_items: ', line_items);

          if (!localStorage.getItem(`cartTokenSent-${updatedToken}`)) {
            await coupleCartToCustomer({ token, line_items }, customerEmail, store);
          }
      } catch (error) {
          console.error("Error fetching cart data:", error);
      }
  } else {
      console.log("No customer is logged in.");
  }
});

// Example of sending the cart token to your backend
const coupleCartToCustomer = async (cartData, customerEmail, store) => {
  try {
      // todo: create function for this
      console.log('cartData: ', cartData);
      const response = await fetch('https://europe-west1-the-acquired-8fc4f.cloudfunctions.net/shopifyCoupleCartToCustomer', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({
              cartData: cartData,
              customerEmail: customerEmail,
              shopifyShopDomain: store,
          })
      });
      if (response.ok) {
          const updatedToken = cartData.token.split('?')[0];
          localStorage.setItem(`cartTokenSent-${updatedToken}`, 'true');
      }
  } catch (error) {
      console.error("Error coupling cart to customer:", error);
  }
};


/*
import { store } from "expo-router/build/global-state/router-store";

const origFetch = window.fetch;

window.fetch = async function(resource, init) {
  const customerEmail = window.customerEmail;
  const resp = await origFetch(resource, init);
  const store = Shopify.shop || '';

  // Detect add-to-cart requests
  if (typeof resource === "string" && resource.includes("/cart/add") && customerEmail) {
    try {
      const clone = resp.clone(); // clone because body can be read once
      const item = await clone.json();
      const cartResponse = await fetch('/cart.js');
      const { token } = await cartResponse.json();
      const data = {
        token,
        item,
        customerEmail,
        shopifyShopDomain: store,
      };
      await fetch('https://europe-west1-the-acquired-8fc4f.cloudfunctions.net/shopifyCartUpdateNew', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
    } catch (err) {
      console.warn("add-to-cart hook failed", err);
    }
  }

  return resp;
};
*/